@if (dataForm()) {
  <div class="wrapper">
    <div class="menu" (click)="toggle()" [ngClass]="method()">
      <p class="email">{{ 'SIGN.Email' | translate }}</p>
      <p class="celular">{{ 'SIGN.Celular' | translate }}</p>
    </div>
    <form [formGroup]="dataForm()" autocomplete="on">
      @switch (method()) {
        @case ('email') {
          <p class="info">{{ 'SIGN.ASEP' | translate }}</p>
          <app-email-input (onEnter)="submit()" />
        }
        @case ('celular') {
          <p class="info">{{ 'SIGN.DSC' | translate }}</p>
          <app-phone-input (onEnter)="submit()" />
        }
      }
      <br />
      <div class="submit-spinner">
        <app-submit-spinner [loading]="loading()" [label]="'SIGN.OC'" [isValid]="valid$ | async" (submit)="submit()" />
      </div>
    </form>
    @if (showWarning$ | async) {
      <div class="warning">
        <p class="message">{{ errorMassage() | translate }}</p>
      </div>
    }
  </div>
}
